import {AnyAction} from "redux";
import {SET_SCREEN} from "./action";
import {SCREENS} from "../reducers/screen";


/**
 * set the active screen
 * @param screen
 * @return {{type: string, payload: {screen: string}}}
 */
export function setScreen(screen: string) : AnyAction
{
    return {type: SET_SCREEN, payload: {screen}};
}


/**
 * show the leaderboard
 */
export function showLeaderboard() : AnyAction
{
    return {type: SET_SCREEN, payload: {screen: SCREENS.LEADERBOARD}};
}



/**
 * show the how to play screen
 */
export function showHowToPlay() : AnyAction
{
    return {type: SET_SCREEN, payload: {screen: SCREENS.HOW_TO_PLAY}};
}


/**
 * show the main menu
 */
export function showMainMenu() : AnyAction
{
    return {type: SET_SCREEN, payload: {screen: SCREENS.MAIN_MENU}};
}


// WEBPACK FOOTER //
// ./src/ts/store/actions/screens.ts